var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerticalBars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 70,
    viewBox: "0 0 55 70",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8017 1.4003L19.8017 68.5997C19.8017 69.3734 20.3798 70 21.0937 70H34.0105C34.7243 70 35.3024 69.3734 35.3024 68.5997L35.3024 1.4003C35.3024 0.626572 34.7243 0 34.0105 0H21.0928C20.3798 0 19.8017 0.626572 19.8017 1.4003ZM0.0452558 29.2054H0L0 68.5997C0 69.3734 0.578085 70 1.29194 70H14.2088C14.9226 70 15.5007 69.3734 15.5007 68.5997L15.5007 29.2054H15.4554C15.3846 28.9054 15.2238 28.6394 14.9983 28.4492C14.7728 28.259 14.4953 28.1555 14.2096 28.1549H1.29108C0.689943 28.1549 0.189563 28.602 0.0452558 29.2054ZM39.4993 20.3001V68.5997C39.4993 69.3734 40.0774 70 40.7912 70H53.7081C54.4219 70 55 69.3734 55 68.5997V20.3001C55 19.5264 54.4219 18.8998 53.7081 18.8998H40.7912C40.0774 18.8998 39.4993 19.5264 39.4993 20.3001Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalBars);
export default __webpack_public_path__ + "static/media/vertical_bars.c65f42d0d36ca3f5cef75800178db0a2.svg";
export { ForwardRef as ReactComponent };